<template>
  <div v-loading="showFlag">
    <t-card>
      <div class="acceptEditForm">
        <t-form
          label-position="right"
          :label-width="$t('widgetSize.ACCEPT_ORDER_INFO.DETIAL_LABEL_WIDTH')"
        >
          <t-row
            type="flex"
            justify="left
          "
          >
            <!-- 見積子番No -->
            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col :span="5"> -->
            <t-col :span="7">
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              <t-form-item
                :label="$t('resource.ADD_ALL_ORDER_INFO.QUOTE_CHILD_NO')"
                class="marginBottom"
              >
                <t-input v-model="quoteNoStr" class="commonDialog" disabled>
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 受注日 -->
            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col :span="5"> -->
            <t-col :span="7">
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              <t-form-item
                :label="$t('resource.ACCEPT_ORDER.ACCEPT_DATE')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="aobAcceptDate"
                  class="dialogDate"
                  :clearable="false"
                  :editable="false"
                  type="date"
                  :disabled="!editFlg"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>

            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col :span="5" v-if="showFlg"> -->
            <t-col :span="7" v-if="showFlg">
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              <t-form-item
                :label="$t('resource.orderInfo.orderDate')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="odDate"
                  class="dialogDate"
                  :clearable="false"
                  :editable="false"
                  :disabled="!editFlg"
                  type="date"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <!-- 製品クローズ選択テーブル -->
      <t-table
        ref="productChangeDetailData"
        :data="productChangeDetailData"
        class="table_common"
        header-cell-class-name="bg-default"
        :cell-class-name="tableCellClassName"
        highlight-current-row
        :height="detailHeight"
        border
      >
        <!-- テーブルの列 -->
        <t-table-column
          v-for="(column, index) in columns"
          :key="index"
          :type="column.type"
          :prop="column.prop"
          :label="column.label"
          :min-width="column.width"
          :align="column.align"
          :header-align="column.headerAlign"
          :class-name="column.class"
          :show-overflow-tooltip="column.overflowTooltip"
        >
          <template slot-scope="scope">
            <t-input-number
              v-if="column.prop === 'aodProdChangeQuantity' && editFlg"
              class="cell_input_number"
              :controls="false"
              :precision="0"
              :min="-99999"
              :max="99999"
              @focus="selectValue($event)"
              v-model="scope.row[column.prop]"
              :ref="`input${scope.row.index}${column.prop}`"
              @keyup.native.enter="focusNextInput(scope.row.index, column.prop)"
            />
            <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_備考機能の追加 -->
            <!-- <t-input
              v-else-if="column.prop === 'aodProdRemarks'"
              v-model="scope.row[column.prop]"
              maxLength="200"
              @focus="selectValue($event)"
              :readonly="!editFlg"
              :ref="`input${scope.row.index}${column.prop}`"
              @keyup.native.enter="focusNextInput(scope.row.index, column.prop)"
            /> -->
            <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

            <span v-else>
              {{ scope.row[column.prop] }}
            </span>
          </template>
        </t-table-column>

        <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
        <!-- 課題_備考機能の追加 -->
        <t-table-column
          :label="$t('resource.REMARKS_ADD.REMARKS')"
          class="cell_txt_center"
          :min-width="100"
        >
          <template slot-scope="scope">
            <div class="button-container">
              <!-- 備考表示 -->
              <t-tooltip v-if="!editFlg" placement="bottom" effect="light">
                <div
                  class="tooltip-content"
                  slot="content"
                  v-html="formatRemarksShowProc(scope.row.aodProdRemarksSum)"
                ></div>
                <t-button
                  :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                  icon="el-icon-search"
                  size="small"
                  circle
                >
                </t-button>
              </t-tooltip>
              <!-- 備考追加 -->
              <t-button
                v-if="editFlg"
                type="warning"
                icon="el-icon-edit"
                size="small"
                :disabled="
                  scope.row.aodProdChangeQuantity == '' ||
                  scope.row.aodProdChangeQuantity == undefined ||
                  scope.row.aodProdChangeQuantity == 0
                "
                circle
                @click="addRemarksProd(scope.row, $event)"
              ></t-button>
            </div>
          </template>
        </t-table-column>
        <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
      </t-table>

      <div :style="{ height: 50 + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-row type="flex" justify="end">
            <t-col :span="21" class="right" v-show="showFlg">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="conOrdfirmBtn"
                :disabled="!editFlg"
                @click="createOrderInfoClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.button.order_button") }}</t-button
              >
            </t-col>

            <t-col :span="3" class="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                :disabled="!editFlg"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { t } from "@/locales";
import { commonApi } from "@/services/common";
import { showRemarksUpdDialog } from "@/services/common";
import {
  cmpBasicData,
  formatDateToString,
  getDialogContentHeight,
  formatRemarksShow,
  getIconType,
} from "@/utils/comFunction";
import { STR_COLON, STR_EMPTY } from "@/utils/const";
import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},

      aobAcceptDate: "",

      odDate: "",

      editFlg: true,

      showFlg: false,

      isAddFlg: "",
      quoteNoStr: "",
      quoteNo: "",
      //読み込み回数
      numLoads: 1,
      //製品クローズ選択テーブル
      productChangeDetailData: [],

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // 編集可能な列
      // columnEditable: ["aodProdRemarks", "aodProdChangeQuantity"],
      columnEditable: ["aodProdChangeQuantity"],
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //製品クローズ選択テーブルの列
      columns: [
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
          overflowTooltip: true,
        },

        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
          overflowTooltip: true,
        },

        {
          prop: "aodProdQuantity",
          label: t("resource.COMMON_CONSTANT.COUNT"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "right",
        },

        {
          prop: "aodProdChangeQuantity",
          label: t("resource.COMMON_CONSTANT.CHANGE_COUNT"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "right",
        },

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // {
        //   prop: "aodProdRemarks",
        //   label: t("resource.COMMON_CONSTANT.BIKOU"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
        //   align: "left",
        //   overflowTooltip: false,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      //明細情報のheight
      detailHeight: getDialogContentHeight(window.innerHeight, 20, 40, 45),

      data: null,

      showFlag: false,
    };
  },
  props: {
    //見積No.
    isAdd: {
      Type: Boolean,
      default: false,
    },
    //見積No.
    aobQuoteNo: {
      Type: String,
      default: STR_EMPTY,
    },
    RowData: {
      Type: Object,
    },
  },
  mounted() {
    this.quoteNo = this.aobQuoteNo;

    this.isAddFlg = this.isAdd;

    if (this.isAddFlg) {
      this.odDate = formatDateToString(new Date());

      this.aobAcceptDate = formatDateToString(new Date());

      this.GetProductQtyDetailData({
        aobQuoteNo: this.quoteNo,
        aodQuoteChildNo: "00",
      });
    } else {
      this.showFlg = true;
      this.quoteNoStr = this.RowData.aodQuoteChildNoStr;

      // console.log(this.RowData.odDate ? true : false);

      this.editFlg = this.RowData.odDate ? false : true;

      this.odDate = this.RowData.odDate || formatDateToString(new Date());

      this.aobAcceptDate =
        this.RowData.aobAcceptDate || formatDateToString(new Date());

      this.GetProductQtyDetailData(this.RowData);
    }

    // this.Init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 製品数変更基本情報の検索
    GetProductQtyDetailData(data) {
      this.showFlag = true;

      commonApi(httpApi.GetProductQtyDetailData, data)
        .then((res) => {
          this.productChangeDetailData = res;

          if (this.isAddFlg) {
            this.quoteNoStr =
              this.productChangeDetailData[0].aodQuoteChildNoStr;
          }

          this.productChangeDetailData.forEach((element, index) => {
            element.index = index;
          });

          // 読み込み回数 = 1
          if (this.numLoads == 1) {
            // 比較用基本情報
            this.cmpBasicResult = JSON.parse(
              JSON.stringify({
                odDate: this.odDate || "",
                aobAcceptDate: this.aobAcceptDate,
              })
            );

            // 比較用明細情報
            this.cmpDetailResult = JSON.parse(
              JSON.stringify(this.productChangeDetailData)
            );

            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }
          // 列幅に自動調整
          setColumnWidth(this.columns, this.productChangeDetailData);

          // データの読み込
          // this.dataProcess(res);
        })
        .catch((err) => {
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.productChangeDetailData.length - 1) {
        this.$refs[`input${0}${columnProp}`][0].focus();
      } else {
        this.$refs[`input${index}${columnProp}`][0].focus();
      }
    },

    confirmClickInputCheck() {
      let inputCheck = true;
      let message;

      let allHaveValue = this.productChangeDetailData.every(
        (item) =>
          item.aodProdChangeQuantity === null ||
          item.aodProdChangeQuantity === undefined
      );

      if (allHaveValue) {
        Modal.showWarning("", t("message.COMMON.CLOSE_NG_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }

      this.productChangeDetailData.forEach((element) => {
        element.aobAcceptDate = this.aobAcceptDate;
        element.isAddFlg = this.isAddFlg;

        let aodProdChangeQuantityFlg = element.aodProdChangeQuantity || true;
        let aodProdRemarksFlg = element.aodProdRemarks || true;

        if (aodProdRemarksFlg !== true && aodProdChangeQuantityFlg === true) {
          message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.COMMON.CLOSE_NG_CHECK");

          inputCheck = false;
          return false;
        }

        if (
          element.aodProdQuantity + (element.aodProdChangeQuantity || 0) <
          0
        ) {
          message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.COMMON.CLOSE_NG_CHECK");

          inputCheck = false;
          return false;
        }
      });

      if (!inputCheck) {
        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }

      return true;
    },

    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      if (!this.confirmClickInputCheck()) {
        return;
      }

      this.showFlag = true;

      commonApi(httpApi.CreatProductQtyDetailData, this.productChangeDetailData)
        .then((res) => {
          this.showMessage(true);

          this.isAddFlg = false;

          this.GetProductQtyDetailData({
            aobQuoteNo: this.quoteNo,
            aodQuoteChildNo: res.split(STR_COLON)[1],
          });

          this.numLoads = 1;

          this.showFlg = true;
        })
        .catch((err) => {
          if (err.data != null) {
            if (err.data.Messages[0].Message === "qtyError") {
              Modal.showError("", t("message.COMMON.CLOSE_NG_CHECK"), {
                $type: "prompt",
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              })
                .then(() => {
                  // 用户点击确认
                  resolve(true);
                })
                .catch((error) => {});
            } else {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            }
          } else {
            this.showMessage(false);
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 手配作成点击
    createOrderInfoClick() {
      // フォーカス削除
      this.$refs.conOrdfirmBtn.$el.blur();

      if (this.confirmClickInputCheck()) {
        // 手配作成
        this.createOrderInfo();
      }
    },

    // 手配作成
    createOrderInfo() {
      this.showFlag = true;

      this.productChangeDetailData.forEach((element) => {
        element.aobAcceptDate = this.aobAcceptDate;
        element.odDate = this.odDate;
      });

      commonApi(
        httpApi.CreatProductQtyOrderDetailData,
        this.productChangeDetailData
      )
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.$emit("ok", "");
        })
        .catch((err) => {
          Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));

          this.GetProductQtyDetailData({
            aobQuoteNo: this.quoteNo,
            aodQuoteChildNo: this.productChangeDetailData[0].aodQuoteChildNo,
          });
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        20,
        40,
        45
      );
    },

    // セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
      if (
        this.columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        if (this.editFlg) {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
    },

    showMessage(flg) {
      if (this.isAddFlg) {
        if (flg) {
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
        } else {
          Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
        }
      } else {
        if (flg) {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
        } else {
          Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        }
      }
    },

    changeCheck() {
      let isDataChanged = false;

      for (let index = 0; index < this.cmpDetailResult.length; index++) {
        const element1 = this.cmpDetailResult[index];
        const element2 = this.productChangeDetailData[index];

        var jsonString1 = JSON.stringify(element1);
        var jsonString2 = JSON.stringify(element2);

        isDataChanged = jsonString1 != jsonString2;

        if (isDataChanged) {
          break;
        }
      }

      if (!isDataChanged) {
        // if (this.isAddFlg) {
        //   isDataChanged = this.productChangeDetailData.length > 0;
        // } else {
        isDataChanged = !cmpBasicData(this.cmpBasicResult, {
          odDate: this.odDate || "",
          aobAcceptDate: this.aobAcceptDate,
        });
        // }
      }

      return isDataChanged;
    },

    //入力ボックスをクリックすると、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },

    //ダイアログを閉じる
    onCancel() {
      if (this.changeCheck()) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      showRemarksUpdDialog(
        this,
        row.aobQuoteNo,
        row.aodProdNo,
        row.aodProdRemarksSum
      ).finally(() => {
        this.numLoads = 1;

        if (this.showFlag) {
          this.showFlag = false;
        }
      });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.cell_input .el-input__inner {
  height: 25px !important;
  padding: 0 5px !important;
}
</style>

